import React from 'react';
import {connect} from "react-redux";
import {
  SIDEBAR_NAVIGATION_BUTTONS,
  SQFT_APPLIANCES, SQFT_APPLIANCES_BATHROOM,
  SQFT_APPLIANCES_CAES,
  SQFT_CABINET_APPLIANCES
} from "../../../../constants";
import SqftNavAppliancesItem from "./SqftNavAppliancesItem";
import {hardCodeIsCaesarStone} from "../../../../../../misc/fabricatorHardcode";
import {getIsBathroom} from "../../../../../kvComponent/navigation/countertopSwitchers";

const getAppliances = () => {
  const isBathroom = getIsBathroom();
  if (hardCodeIsCaesarStone()) return { ...SQFT_APPLIANCES_CAES };
  if (isBathroom) return SQFT_APPLIANCES_BATHROOM;
  return { ...SQFT_CABINET_APPLIANCES, ...SQFT_APPLIANCES };
};

const SqftNavAppliances = (props) => {
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.appliances;
  const appliances = getAppliances();
  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")} data-content="appliances" id="appliances-overlay">
      <div className="content-inner">
        <div className="lightbox-title-block">
          <span className="h7" data-text="sqft.navigation.appliances.title">Select Appliances</span>
        </div>
        <div className="lightbox-button-block">
          <div className="lightbox-cancel-button" data-text="sqft.navigation.overlay.closeButton">Close</div>
        </div>
        <div className="lightbox-options-wrapper" id="appliances-overlay-items">
          {expanded ?
            Object.keys(appliances).map((itemName, index) =>
              <SqftNavAppliancesItem itemName={itemName} key={index}/>
            )
          : null}
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => (store.sqftMenuState);

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavAppliances);
